import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import Swal from "sweetalert2";
import mime from "mime";

const FileNDocViewer = () => {
  const { fileLink, courseId, fileOf, cid, ctype, id, studentid, stdname } =
    useParams();

  const [loading, setLoading] = useState(false);
  const [fileType, setFileType] = useState("No File Type");

  useEffect(() => {
    try {
      const mimeTg = mime.getType(decodeURIComponent(atob(fileLink)));
      if (mimeTg !== fileType) {
        mime.getExtension(mimeTg) !== null
          ? setFileType(mime.getExtension(mimeTg))
          : setFileType("this");
        console.log("type : " + mime.getExtension(mimeTg));
      }
    } catch (error) {
      console.log("Error in mime tag: ", error);
    }
  }, [fileLink, fileType]);

  const viewFileOf =
    fileOf && fileOf?.charAt(0).toUpperCase() + fileOf?.slice(1);

  return (
    <>
      {ctype && ctype === "chapter" ? (
        <Breadcrumb
          txt="Manage Chapter"
          subpath={[
            "View Chapters",
            "Chapter Details",
            `View ${viewFileOf && viewFileOf}`,
          ]}
          url={["/viewchapters", `/viewchapter/${cid}`]}
        />
      ) : ctype && ctype === "course" ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={[
            "View Courses",
            "Course Details",
            `View ${viewFileOf && viewFileOf}`,
          ]}
          url={["/viewcourses", `/viewcourse/${cid}`]}
        />
      ) : studentid ? (
        <Breadcrumb
          txt="Manage Assignment"
          subpath={[
            "Student List",
            "View Uploaded Assignments",
            "Assignment Preview",
          ]}
          url={[
            `/studentsubmissions/${id}`,
            `/viewstudentassignment/${id}/${studentid}/${stdname}`,
          ]}
        />
      ) : (
        ""
      )}

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-body row g-3">
            {loading ? (
              <Spinner />
            ) : (
              <div className="col-lg-12">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1">
                  <div className="me-1 ">
                    <h5 className="mb-1">
                      View {studentid ? "Assignment" : viewFileOf}
                      {/* -{" "}
                      {decodeURIComponent(atob(fileLink)).split(/[.-/]/)
                        .length > 1
                        ? decodeURIComponent(atob(fileLink)).split(/[.-/]/)[
                            decodeURIComponent(atob(fileLink)).split(/[.-/]/)
                              .length - 2
                          ]
                        : decodeURIComponent(atob(fileLink)).split(/[.-/]/)
                            .length > 0
                        ? decodeURIComponent(atob(fileLink)).split(/[.-/]/)[
                            decodeURIComponent(atob(fileLink)).split(/[.-/]/)
                              .length - 1
                          ]
                        : "UNDEFINED"} */}
                    </h5>
                  </div>
                </div>
                <div className="p-2">
                  <div className="border-3 p-2 rounded mt-4">
                    {fileType === "jpeg" ||
                    fileType === "png" ||
                    fileType === "txt" ? (
                      <iframe
                        className=" flex justify-center w-full h-96"
                        src={decodeURIComponent(atob(fileLink))}
                      ></iframe>
                    ) : fileType === "doc" ? (
                      <iframe
                        height={"500px"}
                        width={"100%"}
                        src={`https://docs.google.com/gview?url=${decodeURIComponent(
                          atob(fileLink)
                        )}&embedded=true`}
                      ></iframe>
                    ) : fileType === "xlsx" ? (
                      <iframe
                        height={"500px"}
                        width={"100%"}
                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${decodeURIComponent(
                          atob(fileLink)
                        )}&embedded=true`}
                      ></iframe>
                    ) : (
                      <div className="flex justify-center">
                        <div>
                          <p className="">
                            Sorry, {fileType} file format is not supported!
                          </p>
                          {fileType !== "this" && (
                            <p className="text-center">
                              You can still download the file.
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                    {fileType !== "this" && (
                      <div className="mb-0 pt-1 my-3 py-1 flex justify-center">
                        <a href={decodeURIComponent(atob(fileLink))} download>
                          <i className="mdi mdi-file mdi-20px text-success me-3"></i>
                          Download {studentid ? "Assignment" : viewFileOf}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FileNDocViewer;
